export default __webpack_public_path__ + "static/media/edge.b8b8e6e0.svg";